<template>
  <transition name="slideup">
    <div
      v-if="isOpenCartDialog"
      id="dialog-market"
      class="dialog-bottom dialog-item"
      :class="{ active: isOpenCartDialog }"
    >
      <div
        class="close-dialog dialog-mask mask"
        data-target="#dialog-market"
        @click.prevent="closeMobileCartDialog"
      />

      <div class="addon-dialog">
        <a class="btn-delete" @click.prevent="closeMobileCartDialog" />
        <div class="addon-dialog-content">
          <div class="addon-item-detail clearfix">
            <div class="addon-item-img">
              <new-image
                v-if="selectedData.Images.length !== 0"
                :url="selectedData.Images[0].Url"
                :size="'_w245_h315'"
                :name="itemDatas.Name"
              />
            </div>
            <div class="addon-item-info">
              <div class="addon-item-order">
                <div>
                  <h3 class="item-name">{{ itemDatas.Name }}</h3>
                </div>
                <p
                  v-if="selectedSpec !== null && selectedSpec.PreOrder"
                  style="font-size: 12px"
                  class="my-2"
                >
                  {{ itemDatas.ArrivalExplanation }}
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="py-2 item-price">
                    <span
                      v-if="
                        itemDatas.SellPrice !== itemDatas.OriginPrice || itemDatas.EventPrice > 0
                      "
                      class="origin-price"
                    >
                      {{ itemDatas.OriginPrice }}
                    </span>
                    <span class="sell-price">NT$ {{ getEventPrice }}</span>
                  </div>
                  <div>
                    <div v-for="event in itemDatas.Events" :key="event.ID" class="h6 text-right">
                      <span class="event-name">{{ event.Name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="addon-select-block">
                <div class="color-name-wrap">
                  <ul class="product-color cart-addon-product-color">
                    <li
                      v-for="color in itemDatas.Colors"
                      :key="color.ID"
                      class="item-color"
                      :class="{ active: color.ID === selectedData.ID }"
                      @click="changeImg(color.ID)"
                    >
                      <img :src="color.PintSizePictureUrl + '?w=20&amp;h=20'" />
                    </li>
                  </ul>
                  <div class="color-name">
                    {{ selectedData.Name }}
                  </div>
                </div>
                <ul class="addon-size-wrap">
                  <li
                    v-for="spec in selectedData.Specs"
                    :key="spec.ID"
                    :class="{
                      weak: spec.Stock === 0,
                      selected: spec.ID === selectedSpecID,
                      preshow: itemDatas.IsPreShow,
                    }"
                    @click="selectSpec(spec)"
                  >
                    {{ spec.Name }} {{ spec.Description }}
                  </li>
                </ul>
                <div class="addon-select-pc">
                  <div class="UiQuantity">
                    <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="reduceCount">
                      –
                    </a>
                    <span class="UiQuantity__text">
                      {{ counter < 10 ? '0' + counter : counter }}</span
                    >
                    <a
                      class="UiQuantity__btn UiQuantity__btn--plus"
                      @click.prevent="
                        addCount({ maxCount: selectedSpec.Stock, limit: itemDatas.Limit })
                      "
                    >
                      ＋
                    </a>
                  </div>
                  <button
                    class="btn btn-add2cart btn-primary"
                    :class="btnStyleGenerate"
                    @click.prevent="clickToCart"
                  >
                    {{ btnDescriptionGenerate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="addon-select-m">
            <div class="UiQuantity">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="reduceCount">–</a>
              <span class="UiQuantity__text">{{ counter < 10 ? '0' + counter : counter }}</span>
              <a
                class="UiQuantity__btn UiQuantity__btn--plus"
                @click.prevent="addCount({ maxCount: selectedSpec.Stock, limit: itemDatas.Limit })"
              >
                ＋
              </a>
            </div>
            <button class="btn btn-add2cart" :class="btnStyleGenerate" @click.prevent="clickToCart">
              {{ btnDescriptionGenerate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from 'jquery';
import AlertDialog from '@global/helpers/alertDialog';
import NewImage from '@global/components/global/image';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'SpecMobile',
  components: { NewImage },
  computed: {
    ...mapState('shopContent', [
      'selectedData',
      'selectedSpecID',
      'itemDatas',
      'selectedSpec',
      'counter',
      'isOpenCartDialog',
      'btnStyleGenerate',
      'btnDescriptionGenerate',
    ]),
    getEventPrice() {
      return this.itemDatas.EventPrice > 0 && this.itemDatas.EventPrice < this.itemDatas.SellPrice
        ? this.itemDatas.EventPrice
        : this.itemDatas.SellPrice;
    },
  },
  methods: {
    ...mapActions('shopContent', ['addToCart', 'selectSpec', 'changeImg']),
    ...mapMutations('shopContent', ['addCount', 'reduceCount', 'closeMobileCartDialog']),
    clickToCart() {
      this.addToCart()
        .then((resolve) => {
          if (resolve === undefined) return;
          const { code, response } = resolve;

          switch (code) {
            case 200:
              $('#lb-add-to-cart').modal('show');
              setTimeout(() => {
                $('#lb-add-to-cart').modal('hide');
                window.location.reload();
              }, 2000);
              break;
            case 205:
              AlertDialog.alert('商品已售完', () => {
                window.location.reload();
              });
              break;
            default:
              AlertDialog.alert(response);
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};
</script>
